module.exports = __webpack_public_path__ + "img/energy-badge.c0fe53f9.png";